import React from "react";
import classNames from "classnames";

interface IProps {
  className?: string;
  children: React.ReactNode;
}

export default function H1({ children, className }: IProps) {
  return (
    <h1
      className={classNames(className, "text-bold text-2xl md:text-4xl py-4")}
    >
      {children}
    </h1>
  );
}
